export default __webpack_public_path__ + "static/media/logo.740b0922.svg";